module.exports = __webpack_public_path__ + "static/media/plebiscite.37571780.png";